import { useState } from "react";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, messageErreur } from "@/lib/api";
import { ChoixListe } from "@/pages/parametres/ChoixListe";

export const ImportDialog = ({ ouvert, setOuvert }) => {
  const [analyse, setAnalyse] = useState(null);
  const [corresp, setCorresp] = useState({});
  const [doublons, setDoublons] = useState(false);
  const [resultat, setResultat] = useState(null);
  const fermer = (o) => { setOuvert(o); if (!o) { setAnalyse(null); setResultat(null); } };

  const charger = async (e) => {
    const fichier = e.target.files?.[0];
    if (!fichier) return;
    const fd = new FormData();
    fd.append("fichier", fichier);
    try { const { data } = await api.post("/import/contacts/analyse", fd); setAnalyse(data); setCorresp(data.proposition); }
    catch (err) { toast.error(messageErreur(err)); }
  };
  const importer = async () => {
    try { const { data } = await api.post("/import/contacts/executer", { jeton: analyse.jeton, correspondance: corresp, importer_doublons: doublons }); setResultat(data); toast.success(`${data.crees} contact(s) importé(s).`); }
    catch (err) { toast.error(messageErreur(err)); }
  };

  return (
    <Dialog open={ouvert} onOpenChange={fermer}>
      <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="import-dialog">
        <DialogHeader>
          <DialogTitle>Importer des contacts</DialogTitle>
          <DialogDescription className="at-muted">Fichier CSV ou Excel. Les doublons sont détectés sur le téléphone et l'e-mail.</DialogDescription>
        </DialogHeader>
        {!analyse && (
          <label className="at-soft flex flex-col items-center justify-center gap-2 p-8 cursor-pointer" data-testid="import-dropzone">
            <Upload size={22} /><span className="font-semibold">Choisir un fichier</span>
            <input type="file" accept=".csv,.xlsx" className="sr-only" onChange={charger} data-testid="import-file-input" />
          </label>
        )}
        {analyse && !resultat && (
          <div className="space-y-3">
            <p className="text-sm"><b>{analyse.nb_lignes}</b> lignes détectées. Associez chaque colonne à un champ :</p>
            {analyse.colonnes.map((col, i) => (
              <div key={i} className="grid grid-cols-[1fr_1fr] gap-2 items-center" data-testid={`import-map-row-${i}`}>
                <div className="min-w-0"><p className="font-semibold text-sm truncate">{col || `Colonne ${i + 1}`}</p><p className="text-xs at-muted truncate">{analyse.apercu[0]?.[i]}</p></div>
                <ChoixListe valeur={corresp[i] || "_"} onChange={(v) => setCorresp({ ...corresp, [i]: v === "_" ? "" : v })} options={[{ code: "_", label: "Ignorer" }, ...Object.entries(analyse.cibles).map(([k, l]) => ({ code: k, label: l }))]} testId={`import-map-select-${i}`} />
              </div>
            ))}
            <label className="flex items-center gap-3 min-h-[44px] text-sm"><input type="checkbox" checked={doublons} onChange={(e) => setDoublons(e.target.checked)} className="w-5 h-5" data-testid="import-duplicates-checkbox" />Importer aussi les doublons</label>
            <button type="button" onClick={importer} className="at-btn at-btn-primary w-full" data-testid="import-run-button">Importer</button>
          </div>
        )}
        {resultat && (
          <div className="space-y-2" data-testid="import-result">
            <p className="font-bold">{resultat.crees} contact(s) créé(s) · {resultat.doublons.length} doublon(s) écarté(s) · {resultat.erreurs.length} erreur(s)</p>
            {resultat.doublons.map((d) => <p key={d.ligne} className="text-sm at-soft p-2">Ligne {d.ligne} : {d.nom} {d.telephone} {d.email}</p>)}
            {resultat.erreurs.map((d) => <p key={d.ligne} className="text-sm at-soft p-2" style={{ color: "var(--danger)" }}>Ligne {d.ligne} : {d.message}</p>)}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
